import { api } from './apiClient';
import type { CustomPalette } from '@/theme/themes';

export interface UserSettings {
  preferredLang?: string;
  autoplay?: boolean;
  // Server returns `null` when the user has not customized a theme; a stored
  // palette comes back as a JSON object. Anything else is rejected client-side
  // by `isCustomPalette` in the theme layer.
  customTheme?: CustomPalette | null;
  /** Site UI locale for i18n (distinct from preferredLang). */
  language?: 'en' | 'es';
}

export interface SettingsResponse {
  settings: UserSettings;
}

export interface SettingsUpdateInput {
  preferredLang?: string;
  autoplay?: boolean;
  // Pass `null` to clear a saved palette; omit to leave it alone.
  customTheme?: CustomPalette | null;
  language?: 'en' | 'es';
}

export const settingsApi = {
  get(): Promise<SettingsResponse> {
    return api<SettingsResponse>('/api/settings', { auth: true });
  },
  update(input: SettingsUpdateInput): Promise<SettingsResponse> {
    return api<SettingsResponse>('/api/settings', {
      method: 'PATCH',
      body: input,
      auth: true,
    });
  },
};
